import { render, staticRenderFns } from "./VButtonPrev.vue?vue&type=template&id=763cd1b9&scoped=true&"
var script = {}
import style0 from "./VButtonPrev.vue?vue&type=style&index=0&id=763cd1b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763cd1b9",
  null
  
)

export default component.exports